/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import RatingsHistogram from './ratings-histogram';
import RatingsHistogramView from './ratings-histogram.view';

export * from './component/components';
export * from './ratings-histogram';
export * from './ratings-histogram.data';
export { IRatingsHistogramConfig, IRatingsHistogramProps, IRatingsHistogramResources } from './ratings-histogram.props.autogenerated';
export * from './ratings-histogram.view';

export { RatingsHistogram, RatingsHistogramView };
